import React from 'react';
import MUIDataTable from 'mui-datatables';
import ExcelIcon from '../../../Assets/Excel-Logo.png';
import {
  MuiThemeProvider,
  createTheme,
  makeStyles,
  useTheme,
} from '@material-ui/core/styles';
import { overridings as lightTheme } from '../../../Utils/themes/light-theme';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Box, withStyles } from '@material-ui/core';
import tableJson from './tableData.json';
import { useTranslation } from 'react-i18next';
import SearchBox from '../../../Components/SearchBox/index';
import { Grid } from '@material-ui/core';
import JobsDataTable from './jobsDataTable';
import FileUploadStatus from '../../../Components/KenFileUploadStatus/index';
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined';
import context from '../../..//Utils/context';
import DownloadIcon from '@material-ui/icons/GetApp';
import KenLoader from '../../../Components/KenLoader/index';
import { CircularProgress } from '@material-ui/core';

//apiMethod

import {
  getJobDetails,
  getSubJobDetails,
  getErrorLog,
} from '../../../Utils/apiServices';
import KenButton from '../../../global_components/KenButton';

const useStyles = makeStyles((theme) => ({
  //Filter Icon
  filterIcon: {
    height: '12px',
    width: '12px',
    margin: '3px 0px -3px 5px',
  },
  //Filter Dropdown
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },

  // Search
  SearchBoxContainer: {
    float: 'right',
    position: 'absolute',
    top: '13px',
    right: '14px',
    // width: '136px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  // Table
  tableCaption: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.KenWhite,
  },
  //modal
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(5, 4, 5),
    borderRadius: 3,
    fontFamily: 'Open Sans,sans-serif',
    // width: "50%",
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% - 40%)',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'calc(100% - 15%)',
    },
  },
  rootWrap: {
    width: '100%',
    marginTop: 10,
    maxHeight: 400,
    overflow: 'auto',
    minWidth: '700px',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      backgroundColor: 'rgba(0,0,0,.2)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey',
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 300,
      minWidth: '100%',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  modalHeader: {
    borderBottom: `1px solid ${theme.palette.KenColors.neutral40}`,
    paddingBottom: 20,
  },
  modalSubHeader: {
    marginTop: 28,
    paddingBottom: 5,
    fontSize: 16,
  },
  summaryWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  SearchBoxContainer: {
    float: 'right',
    position: 'absolute',
    top: '13px',
    right: '14px',
    // width: '136px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  headIcon: {
    color: theme.palette.KenColors.tertiaryOrange50,
  },
  rowDetails: {
    marginTop: 16,
  },
  rowDetailStatus: {
    borderCollapse: 'collapse',
    width: '40%',
    [theme.breakpoints.down('xs')]: {
      width: '70%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },

  tableDataStatus: {
    textAlign: 'left',
    padding: 8,
    fontSize: 14,
  },
}));

const StyledAccordion = withStyles((theme) => ({
  root: {
    padding: 0,
    overflow: 'hidden',
  },
}))(AccordionSummary);

export default function DataTable(props) {
  const classes = useStyles();
  const { reloadJobs } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const { config, handleLoader } = React.useContext(context);

  const [tableData, setTableData] = React.useState([]);
  const [tableLoading, setTableLoading] = React.useState(true);

  const [loading, setLoading] = React.useState(false);

  const [initialTableData, setInitialTableData] = React.useState([]);

  const [subJobTableData, setSubJobTableData] = React.useState({});

  const searchTableHandler = (event) => {
    let searchString = event.target.value;
    let columnsToFilter = [...initialTableData];
    let searchResult = columnsToFilter.filter((column) => {
      return (
        column.jobName.toLowerCase().includes(searchString.toLowerCase()) ||
        column.startTime.toLowerCase().includes(searchString.toLowerCase()) ||
        column.endTime.toLowerCase().includes(searchString.toLowerCase()) ||
        column.status.toLowerCase().includes(searchString.toLowerCase())
      );
    });

    setTableData(searchResult);
  };

  const columns = [
    {
      name: 'jobId',
      label: 'JobId',
      options: {
        display: false,
      },
    },
    {
      name: 'jobName',
      label: t('job_Name'),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={ExcelIcon} style={{ width: 30 }}></img>
            <p style={{ marginLeft: 10 }}>{value}</p>
          </div>
        ),
      },
    },
    {
      name: 'startTime',
      label: t('start_Date'),
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'endTime',
      label: t('end_Date'),
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'status',
      label: t('status'),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <FileUploadStatus value={value} />
        ),
      },
    },
  ];

  const tableTheme = createTheme({
    ...lightTheme,
    overrides: {
      MuiTable: {
        root: {
          borderSpacing: '0px',
          borderCollapse: 'separate',
        },
      },
      MuiToolbar: {
        root: {
          textAlign: 'left',
          backgroundColor: theme.palette.KenColors.KenWhite,
        },
        title: {
          fontSize: 18,
        },
      },
      MUIDataTableHeadCell: {
        sortAction: {
          alignItems: 'center',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        sortActive: {
          color: theme.palette.KenColors.neutral400,
        },
        root: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: '14px',
          color: theme.palette.KenColors.neutral400,
        },
        fixedHeader: {
          padding: '12px',
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: 'none',
          padding: '12px 10px',
          fontSize: '14px',
          borderBottom: `1px solid ${theme.palette.KenColors.neutral40}`,
          color: theme.palette.KenColors.neutral400,
        },
        head: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '14px',
        },
      },
      MuiTablePagination: {
        toolbar: {},
      },
      MuiPaper: {
        elevation4: {
          boxShadow:
            '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
        },
        rounded: {},
      },
      MuiTableRow: {
        root: {
          '&:hover': {
            cursor: 'pointer',
          },
        },
        footer: {},
      },
      MUIDataTableHeadRow: {
        root: {},
      },
      MUIDataTableBodyRow: {
        stackedParent: {
          padding: '0px',
        },
      },
    },
  });

  // set table configuration
  const muiDataTableOptions = {
    selectableRows: 'none',
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    search: false,
    expandableRowsHeader: true,
    rowsPerPageOptions: [10, 20, 30],
    filterType: 'dropdown',
    onRowClick: (rowData, rowMeta) => {
      openModal(tableData[rowMeta.rowIndex].jobId);
      setOpen(true);
    },
    customToolbar: () => {
      return (
        <div className={classes.SearchBoxContainer}>
          <SearchBox searchHandler={searchTableHandler} />
        </div>
      );
    },
    sortOrder: {
      name: 'jobName',
      direction: 'asc',
    },
  };

  //sub job api

  const openModal = (jobId) => {
    setLoading(true);
    const instituteId = config.instituteId;
    const jobDetails = getSubJobDetails(instituteId, jobId)
      .then((res) => {
        console.log(res, 'subJobs');
        setSubJobTableData(res);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, 'err');
        setLoading(false);
      });
  };

  // table data api

  React.useEffect(() => {
    const instituteId = config.instituteId;
    const tableJson = getJobDetails(instituteId)
      .then((res) => {
        console.log('reloading jobs table');
        // setLoading(true);
        setTableData([...res]);
        setInitialTableData([...res]);
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err, 'err');
        setTableLoading(false);
      });
  }, [reloadJobs]);

  //download json data

  const downloadJsonFile = (content, fileName, contentType) => {
    const a = document.createElement('a');
    const file = new Blob([content], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  };

  const downloadErrorLog = async (jobId) => {
    let downloadFile = await getErrorLog(jobId);
    downloadJsonFile(
      JSON.stringify(downloadFile),
      'job-subJob.json',
      'text/plain'
    );
  };

  const jobsArray = [
    {
      jobName: 'Job1',
      status: 'completed',
      steps: [
        {
          name: 'Staging1',
          status: 'completed',
        },
        {
          name: 'Staging2',
          status: 'failed',
        },
        {
          name: 'Curation',
          status: 'pending',
        },
        {
          name: 'Bulk load',
          status: 'running',
        },
      ],
    },
    {
      jobName: 'Job2',
      status: 'completed',
      steps: [
        {
          name: 'Staging1',
          status: 'completed',
        },
        {
          name: 'Staging2',
          status: 'failed',
        },
        {
          name: 'Curation',
          status: 'pending',
        },
        {
          name: 'Bulk load',
          status: 'running',
        },
      ],
    },
  ];

  return (
    <div style={{ marginTop: 20, paddingBottom: 30 }}>
      <MuiThemeProvider theme={tableTheme}>
        <div style={{ position: 'relative' }}>
          {tableLoading && (
            <div
              style={{
                position: 'absolute',
                zIndex: 110,
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'rgba(255,255,255,0.8)',
              }}
            >
              <CircularProgress size={24} />
            </div>
          )}
          <MUIDataTable
            title={t('headings:file_Upload_Reconciliation')}
            data={tableData}
            columns={columns}
            options={muiDataTableOptions}
          />
        </div>
      </MuiThemeProvider>
      <div>
        {loading && <KenLoader />}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          disableScrollLock={true}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 className={classes.modalHeader}>{t('labels:jobDetails')}</h2>
              <Grid className={classes.rowDetails}>
                <table className={classes.rowDetailStatus}>
                  <tr>
                    <td className={classes.tableDataStatus}>
                      {t('labels:number_of_rows')}
                    </td>
                    <td className={classes.tableDataStatus}>
                      {subJobTableData.totalRowCount}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.tableDataStatus}>
                      {t('labels:number_of_rows_processed')}
                    </td>
                    <td className={classes.tableDataStatus}>
                      {subJobTableData.totalSuccessRowCount}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.tableDataStatus}>
                      {t('labels:number_of_rows_with_error')}
                    </td>
                    <td className={classes.tableDataStatus}>
                      {subJobTableData.totalErrorRowCounts}
                    </td>
                  </tr>
                </table>
              </Grid>
              <h2 className={classes.modalSubHeader}>{t('labels:subJobs')}</h2>
              <div className={classes.rootWrap}>
                {subJobTableData &&
                  subJobTableData.stages &&
                  subJobTableData.stages.subJobs.map((item, index) => {
                    return (
                      <Accordion key={index}>
                        <StyledAccordion
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className={classes.summaryWrapper}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                          >
                            <Typography className={classes.heading}>
                              {item.jobName}
                            </Typography>
                            <Typography>
                              <div style={{ display: 'flex' }}>
                                <FileUploadStatus value={item.status} />
                              </div>
                            </Typography>
                          </Box>
                        </StyledAccordion>
                        {item.status === 'failed' ? (
                          <KenButton
                            data-testid="error-button"
                            label={t('labels:error_log')}
                            variant="secondary"
                            startIcon={<DownloadIcon className={classes.img} />}
                            size="small"
                            onClick={downloadErrorLog}
                          />
                        ) : (
                          ''
                        )}
                        <AccordionDetails>
                          <Box>
                            <JobsDataTable data={item.steps} size="small" />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  );
}
